/**
 * @generated SignedSource<<158e066ea7146b65a4986d04eb5d6861>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateDeetCriteriaInput = {
  clientMutationId?: string | null | undefined;
  deetIds?: ReadonlyArray<any | null | undefined> | null | undefined;
};
export type useDeetCriteriaMutation$variables = {
  input: UpdateDeetCriteriaInput;
};
export type useDeetCriteriaMutation$data = {
  readonly updateDeetCriteria: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useDeetCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useDeetCriteriaMutation = {
  response: useDeetCriteriaMutation$data;
  variables: useDeetCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeetCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateDeetCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateDeetCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useDeetCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeetCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateDeetCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateDeetCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "DEET_BY_DEET_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "DeetCriterionConnection",
                    "kind": "LinkedField",
                    "name": "deetCriteria",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DeetCriterion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deetId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "deetCriteria(orderBy:[\"DEET_BY_DEET_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1b476d53bae9880525ddd3759ed21c69",
    "id": null,
    "metadata": {},
    "name": "useDeetCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation useDeetCriteriaMutation(\n  $input: UpdateDeetCriteriaInput!\n) {\n  updateDeetCriteria(input: $input) {\n    query {\n      ...useDeetCriteria_query\n      id\n    }\n  }\n}\n\nfragment useDeetCriteria_query on Query {\n  currentUser {\n    deetCriteria(orderBy: [DEET_BY_DEET_ID__SEQUENCE_ASC]) {\n      nodes {\n        deetId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "807d0e0cfb057c5f55af01e7a8f763e8";

export default node;
